import { connect } from "react-redux";
import Sidebar from "../sidebar/sidebar";
import Header from "../../shared/header/header";
import { withTranslation } from 'react-i18next';
import React, { Component, Fragment } from "react";
import { moduleAction } from "../../utils/functions";
import { getRoles, getSessionInfo } from "../../../Redux/reducer/session";
import { EXECUTE, MOD_BILL, MOD_DISCONT_PROV, MOD_LOG, MOD_PROVID } from "../../../permissions";

/*
 * 1. Dashboard
 * 2. Proveedores
 * 3. Facturas
 * 4. Admisiones
 */

const LOGS_MODULE_USER_TYPES_NOT_ALLOWED = ["CSA", "PRO"];

export class MainTemplate extends Component {
  constructor(props) {
    super(props);
  }

  getAvailableModules() {
    const { roles, t, session: { userType }} = this.props;

    var routes = [
      { id: "dashboard", path: "/dashboard", label: t('sidebarMenu.dashboard.web'), labelMobile: t('sidebarMenu.dashboard.mobile'), order: 1 },
      { id: "reports", path: "/reports", label: t('sidebarMenu.reports.web'), labelMobile: t('sidebarMenu.reports.mobile'), order: 6 }
    ];

    Object.keys(roles).map(item => {
      switch (item) {
        case MOD_BILL:
          routes.push({
            order: 3,
            id: "bills",
            path: "/bills",
            label: t('sidebarMenu.bills.web'),
            labelMobile: t('sidebarMenu.bills.mobile'),
          });
          break;
        case MOD_LOG:
          /* istanbul ignore else */
          if(!LOGS_MODULE_USER_TYPES_NOT_ALLOWED.includes(userType)){
            routes.push({
              order: 5,
              id: "auditLogs",
              path: "/logs",
              label: t('sidebarMenu.logs.web'),
              labelMobile: t('sidebarMenu.logs.mobile'),
            });
          }
          break;
        case MOD_DISCONT_PROV:
        case MOD_PROVID:
          if( routes.filter( route => route.id === "provider" ).length <= 0 ) {
            routes.push({
              order: 2,
              id: "provider",
              path: "/providers",
              label: t('sidebarMenu.provider.web'),
              labelMobile: t('sidebarMenu.provider.mobile'),
            });
            if (moduleAction(roles, MOD_PROVID, EXECUTE) || moduleAction(roles, MOD_DISCONT_PROV, EXECUTE)) {
              routes.push({
                order: 4,
                id: "admissions",
                path: "/admissions",
                label: t('sidebarMenu.admissions.web'),
                labelMobile: t('sidebarMenu.admissions.mobile'),
              });
            }
          }
          break;
      }

      return true;
    });

    return this.orderMenu(routes);
  }

  orderMenu = (menu) => {
    for (var i = 0; i < menu.length; i++) {
      for (var z = 0; z < menu.length - i - 1; z++) {
        if (menu[z].order > menu[z + 1].order) {
          var current = menu[z];
          var next = menu[z + 1];
          menu[z] = next;
          menu[z + 1] = current;
        }
      }
    }

    return menu;
  }

  render() {
    const routes = this.getAvailableModules();
    const className = this.props.className || "";
    return (
      <Fragment>
        <Header />
        <Sidebar menuItems={routes}/>
        <div className={`wrapper-container ${className}`}>
          <div className="content">{this.props.children}</div>
        </div>
      </Fragment>
    );
  }
}

export const mapStateToProps = state => {
  return {
    roles: getRoles(state),
    session: getSessionInfo(state),
  };
};

export default connect(mapStateToProps, null)(withTranslation()(MainTemplate));
